<div class="menu-links-container mapfre-hide-mobile mapfre-hide-tablet" responsive-breakpoints>
  <div [class]="'block-'+i" *ngFor="let item of menuLinks; index as i">
    <h4>{{item.sectionTitle}}</h4>
    <div class="row">
      <ul class="col">
        <li *ngFor="let link of item.block1">
          <a class="menu-link" [href]="link.url" target="_blank">{{link.title}}</a>
        </li>
      </ul>

      <ul *ngIf="item?.block2" class="col">
        <li *ngFor="let link of item?.block2">
          <a class="menu-link" [href]="link.url" target="_blank">{{link.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="responsive-links mapfre-mt-m mapfre-hide-desktop">
  <mat-accordion>
    <mat-expansion-panel *ngFor="let item of menuLinks">
      <mat-expansion-panel-header
        class="dark-blue mapfre-fs-s fw-500">{{item.sectionTitle}}</mat-expansion-panel-header>
      <ul>
        <li *ngFor="let link of item.block1">
          <a class="menu-link" [href]="link.url" target="_blank">{{link.title}}</a>
        </li>

        <li *ngFor="let link of item?.block2">
          <a class="menu-link" [href]="link.url" target="_blank">{{link.title}}</a>
        </li>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="footer-container">
  <div class="footer" responsive-breakpoints>
    <div class="row jc-sb ">
      <div class="col-12 col-md-6 dark-blue">
        MAPFRE © {{year}} Todos los derechos reservados
      </div>

      <div class="col-12 col-md-6 social-media-icons w-50 flex jc-e">
        <img class="mapfre-ml-m cp " (click)="navToSocialMedia(i)" *ngFor="let ele of socialMediaLinks;let i = index"
          [src]="imgPath + ele + '.svg'" alt=" " />
      </div>
    </div>
    <div class="col-12 col-md-8 w-60 flex f-wrap m-0">
      <div *ngFor="let item of footerData.legals" class="dark-blue item my-1 cp border-r " (click)="navTo(item.id) ">
        {{ item?.label | translate }}
      </div>
      <div class="ot-sdk-show-settings"
        style="text-decoration: none; border: 0px !important; background: none; opacity: 1; cursor: pointer; color: #526570; margin: 0.5rem 0rem">
        Configuración de las cookies
      </div>
    </div>
  </div>
</div>